<template>
    <div>
        <br>
        <h3>One-Day Registrant Information</h3>
        <hr>
        <vue-form :state="formstate">
            <div class="row">
                <div class="col">
                    <validate auto-label class="form-group required-field"
                              :class="fieldClassName(formstate.oneDay)">
                        <label>What day are you planning on attending?</label>

                        <select class="form-control" name="oneDay" required
                                v-model.lazy="state.registrantData.oneDayExtraData.day">
                            <option value="sat">Saturday (11/21/2026)</option>
                            <option value="sun">Sunday (11/22/2026)</option>
                        </select>

                        <field-messages name="oneDay" show="$touched || $dirty || $submitted"
                                        class="form-control-feedback">
                            <div>Success!</div>
                            <div slot="required">This is a required field</div>
                        </field-messages>
                    </validate>
                </div>
            </div>
        </vue-form>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'OneDay',
        data: function () {
            return {
                formstate: {},
            }
        },
        computed: {
            ...mapGetters({
                state: 'getState',
            }),

        },
        watch: {
            formstate: function (val) {
                this.state.formstate.oneDay = val;
            },
        },
        methods: {
            fieldClassName: function (field) {

                if (!field) {
                    return ''
                }
                if ((field.$touched || field.$submitted) && field.$valid) {
                    return 'has-success'
                }
                if ((field.$touched || field.$submitted) && field.$invalid) {
                    return 'has-danger'
                }
            },
            onSubmit: function () {
                console.log(this.formstate.$valid)
            }
        },
    }
</script>

<style>
    .required-field > label::after {
        content: '*';
        color: red;
        margin-left: 0.25rem;
    }
</style>
